var xhr;
export var makeRequest = function (method, endpoint, data, onReceiveData) {
    if (xhr) {
        xhr.abort();
    }
    xhr = new XMLHttpRequest();
    xhr.open(method, endpoint);
    if (data.headers) {
        for (var header in data.headers) {
            if (data.headers[header]) {
                xhr.setRequestHeader(header, data.headers[header]);
            }
        }
    }
    xhr.send(JSON.stringify(data.json));
    xhr.onreadystatechange = function () {
        if (!xhr || xhr.readyState !== 4) {
            return;
        }
        if (xhr.status === 200) {
            var responseJson = JSON.parse(xhr.response);
            if (responseJson && responseJson.suggestions) {
                onReceiveData(responseJson.suggestions);
            }
        }
    };
};
